import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, SecurityContext } from '@angular/core';
import { Input } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule, MatSuffix } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import {
  IApnNewSpaceEmailLink,
  ICurrentLotParkingAgreementVerbiage,
  IParkerProfileDetail,
  IParkingAgreementData,
  IParkingAgreementFetchDetail,
  IParkingAgreementNewParkingAgreementLink,
  IParkingAgreementUpdateExemptStatus,
  ISpaceEmailByEntityId,
} from 'src/app/shared/interfaces';
import { DialogConfirmSpaceEmailComponent } from '../../parker-v2-dialogs/dialog-confirm-space-email/dialog-confirm-space-email.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorDialogStopComponent } from 'src/app/core/dialog/error-dialog-stop/error-dialog-stop.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DialogUpdateParkerEmailaddressComponent } from '../../parker-v2-dialogs/dialog-update-parker-emailaddress/dialog-update-parker-emailaddress.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { environment } from 'src/environments/environment';
import { check } from '@igniteui/material-icons-extended';
import { SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-parkers-v2-agreement-preview',
  standalone: false,
  // imports: [
  //   CommonModule,
  //   ReactiveFormsModule,
  //   MatCardModule,
  //   MatFormFieldModule,
  //   MatInputModule,
  //   NgIf,
  //   MatCheckboxModule,
  //   MatSnackBarModule,
  //   MatIconModule,
  //   MatTooltipModule,
  //   MatSuffix,
  //   MatButtonModule,
  //   ClipboardModule,
  //   DatePipe,
  // ],
  templateUrl: './parkers-v2-agreement-preview.component.html',
  styleUrl: './parkers-v2-agreement-preview.component.scss',
})
export class ParkersV2AgreementPreviewComponent implements OnInit {
  parkerFirstName: string = 'First Name';
  linkUrl: string = 'test';
  lotSpecificContractVerbiage: SafeHtml = 'lot contract';
  standardContractVerbiage: SafeHtml = 'standard contract';
  parkingCurrentActiveTemplateDetail: ICurrentLotParkingAgreementVerbiage;
  specialInstructionsLink: string = 'https://www.google.com';
  specialInstuctionsDescription: string = 'Click here for description';
  parkingAgreementLink: string = 'https://www.microsoft.com';
  emailBodySafeHtml: SafeHtml;
  sanitizer: any;
  parkingAgreementData: ICurrentLotParkingAgreementVerbiage;
  baseUrl: string = '';
  lotNumber: string = '';

  //Services
  appGeneralState = inject(AppGeneralStateService);
  dataService = inject(DataService);
  destroyRefService = inject(DestroyRef);
  route = inject(ActivatedRoute);

  constructor() {
    this.baseUrl = environment.RestServer;
  }

  ngOnInit(): void {
    const lotNumber: string = this.route.snapshot.params['lotNumber'];

    this.lotNumber = lotNumber;

    this.getParkingAgreementVerbigeForLot(lotNumber);
  }

  //Get the current parking agreement detail data from datastore
  getParkingAgreementVerbigeForLot(lotNumber: string): void {
    this.dataService
      .GetParkingAgreementVerbiageForLot(lotNumber)
      .pipe(takeUntilDestroyed(this.destroyRefService))
      .subscribe({
        next: (results) => (this.parkingCurrentActiveTemplateDetail = results),
        error: (err) => {},
        complete: () => {},
      });
  }

  sanitizeHtmlContent(htmlstring: string): SafeHtml {
    const htmlContent: any = this.sanitizer.sanitize(SecurityContext.HTML, htmlstring);

    return htmlContent;
  }
}
